import { adminFetch } from '../utils/adminFetch';
import {
  CourseAssessment,
  CourseAssessmentResponseEnvelope
} from '../types/assessment';

const API = process.env.REACT_APP_API_URL;

const json = async <T>(res: Response): Promise<T> => {
  const ct = res.headers.get('content-type') || '';
  const data = ct.includes('application/json') ? await res.json() : null;
  if (!res.ok) {
    const message = (data && (data.error || data.message)) || res.statusText;
    const err = new Error(message) as Error & { status?: number; data?: any };
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data as T;
};

export const fetchCourseAssessment = async (
  courseId: string
): Promise<CourseAssessmentResponseEnvelope> => {
  const res = await adminFetch(`${API}/course-assessments/course/${courseId}`);
  return json(res);
};

export const updateCourseAssessment = async (
  courseId: string,
  payload: Pick<
    CourseAssessment,
    | 'linkedQuestions'
    | 'initialDiagnosticDescription'
    | 'initialDiagnosticQuestions'
    | 'finalImpactDescription'
    | 'finalImpactQuestions'
    | 'followupImpacts'
  >
): Promise<CourseAssessmentResponseEnvelope> => {
  const res = await adminFetch(`${API}/course-assessments/course/${courseId}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  });
  return json(res);
};

export const setCourseAssessmentEnabled = async (
  courseId: string,
  enabled: boolean
): Promise<{ diagnosticImpactEnabled: boolean }> => {
  const res = await adminFetch(
    `${API}/course-assessments/course/${courseId}/enabled`,
    {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ enabled })
    }
  );
  return json(res);
};

export const fetchAssessmentResponses = async (
  courseId: string,
  filters?: { studentId?: string; groupId?: string }
): Promise<{ responses: any[] }> => {
  const params = new URLSearchParams();
  if (filters?.studentId) params.set('studentId', filters.studentId);
  if (filters?.groupId) params.set('groupId', filters.groupId);
  const qs = params.toString();
  const res = await adminFetch(
    `${API}/course-assessments/course/${courseId}/responses${qs ? `?${qs}` : ''}`
  );
  return json(res);
};
